var app = angular.module("leonardo");

var ReportDialog = function($scope, $http, $filter, AccountUserService, ScheduleService, NotificationService,
                            QuickReportsService, FormErrorsService, AuthDataService) {

  $scope.filters = $scope.ngDialogData.filters;
  if($scope.filters.detailed && $scope.filters.fields_active && ReportFilterService.selectedOptionFieldToShow){
    var field_active =  $scope.filters.fields_active.split(',');

    var filteredArray = ReportFilterService.selectedOptionFieldToShow
    .filter(item => {
        item.fields = item.fields.filter(field => field_active.includes(field.key));
        return item.fields.length > 0;
      })
      .map(item => item.id);
    $scope.filters.fields_key = filteredArray.join(',');
  }
  $scope.report_type = $scope.ngDialogData.report_type;
  $scope.schedule = $scope.ngDialogData.schedule;
  $scope.only_superuser = $scope.ngDialogData.only_superuser;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }

    QuickReportsService.post({
      name: $scope.name,
      shared: $scope.shared,
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      account: AccountUserService.currentAccountUser ? AccountUserService.currentAccountUser.account : null,
      schedule: $scope.schedule,
      filters: $scope.filters,
      report_type: $scope.report_type,
      only_superuser: $scope.only_superuser
    }).then(function(data) {
      NotificationService.notify('success', $filter('translate')('The report has been saved successfully'));
      $scope.confirm(data);
    });
  };

};

app.controller('ReportDialog', ['$scope', '$http', '$filter', 'AccountUserService', 'ScheduleService',
  'NotificationService', 'QuickReportsService', 'FormErrorsService', 'AuthDataService', ReportDialog]);
